import { arrayByDifference, nonSecureRandomIdentifier, subtractFromArray } from '@standardnotes/utils';
import { ServerSyncResponse } from '@Lib/Services/Sync/Account/Response';
import { SyncSignal } from '@Lib/Services/Sync/Signals';
export const SyncUpDownLimit = 150;
/**
 * A long running operation that handles multiple roundtrips from a server,
 * emitting a stream of values that should be acted upon in real time.
 */
export class AccountSyncOperation {
    /**
     * @param payloads   An array of payloads to send to the server
     * @param receiver   A function that receives callback multiple times during the operation
     */
    constructor(payloads, receiver, apiService, options) {
        this.payloads = payloads;
        this.receiver = receiver;
        this.apiService = apiService;
        this.options = options;
        this.id = nonSecureRandomIdentifier();
        this.responses = [];
        this.pendingPayloads = payloads.slice();
    }
    /**
     * Read the payloads that have been saved, or are currently in flight.
     */
    get payloadsSavedOrSaving() {
        return arrayByDifference(this.payloads, this.pendingPayloads);
    }
    popPayloads(count) {
        const payloads = this.pendingPayloads.slice(0, count);
        subtractFromArray(this.pendingPayloads, payloads);
        return payloads;
    }
    async run() {
        await this.receiver(SyncSignal.StatusChanged, undefined, {
            completedUploadCount: this.totalUploadCount - this.pendingUploadCount,
            totalUploadCount: this.totalUploadCount,
        });
        const payloads = this.popPayloads(this.upLimit);
        const rawResponse = await this.apiService.sync(payloads, this.options.syncToken, this.options.paginationToken, this.downLimit, this.options.sharedVaultUuids);
        const response = new ServerSyncResponse(rawResponse);
        this.responses.push(response);
        this.options.syncToken = response.lastSyncToken;
        this.options.paginationToken = response.paginationToken;
        try {
            await this.receiver(SyncSignal.Response, response);
        }
        catch (error) {
            console.error('Sync handle response error', error);
        }
        if (!this.done) {
            return this.run();
        }
    }
    get done() {
        return this.pendingPayloads.length === 0 && !this.options.paginationToken;
    }
    get pendingUploadCount() {
        return this.pendingPayloads.length;
    }
    get totalUploadCount() {
        return this.payloads.length;
    }
    get upLimit() {
        return SyncUpDownLimit;
    }
    get downLimit() {
        return SyncUpDownLimit;
    }
    get numberOfItemsInvolved() {
        let total = 0;
        for (const response of this.responses) {
            total += response.numberOfItemsInvolved;
        }
        return total;
    }
}
